import React, { useEffect, useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";
import "./HospitalityPage.css";

const HospitalityPage = () => {
  const [locations, setLocations] = useState([]);
  const [showLocationPopup, setShowLocationPopup] = useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
const [selectedLocation, setSelectedLocation] = useState(null);
const [nightAuditFile, setNightAuditFile] = useState(null);
const [uploading, setUploading] = useState(false);
const navigate = useNavigate();


  const [locationForm, setLocationForm] = useState({
    brand: "",
    location: "",
  });

  useEffect(() => {
  
  fetchLocations();
}, []);


const fetchLocations = async () => {
  try {
    const { data } = await api.get("/hospitality-locations");
    setLocations(data);
  } catch (error) {
    console.error("Error fetching locations:", error);
  }
};

  const handleLocationChange = (e) => {
    const { name, value } = e.target;

    setLocationForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCloseLocationPopup = () => {
    setShowLocationPopup(false);

    setLocationForm({
      brand: "",
      location: "",
    });
  };

  const handleLocationSubmit = async (e) => {
  e.preventDefault();

  try {
    await api.post("/hospitality-locations", {
      brand: locationForm.brand,
      location: locationForm.location,
    });

    handleCloseLocationPopup();

    // Refresh locations after adding
    await fetchLocations();

  } catch (error) {
    console.error("Error adding location:", error);

    alert(
      error?.response?.data?.message ||
      "Failed to add location."
    );
  }
};

const handleOpenUpload = (location) => {
  setSelectedLocation(location);
  setNightAuditFile(null);
  setShowUploadPopup(true);
};

const handleCloseUpload = () => {
  setShowUploadPopup(false);
  setSelectedLocation(null);
  setNightAuditFile(null);
};

const handleNightAuditUpload = async (e) => {
  e.preventDefault();

  if (!selectedLocation?.id) {
    alert("Missing location.");
    return;
  }

  if (!nightAuditFile) {
    alert("Please select a file.");
    return;
  }

  const formData = new FormData();

  formData.append("file", nightAuditFile);

  setUploading(true);

  try {
    let endpoint = "";

    if (selectedLocation.brand === "hilton") {
      endpoint =
        `/hospitality/night-audit/${selectedLocation.id}`;
    } else if (selectedLocation.brand === "seahaus") {
      endpoint =
        `/hospitality/seahaus/night-audit/${selectedLocation.id}`;
    } else if (selectedLocation.brand === "marriott") {
      endpoint =
        `/hospitality/marriott/night-audit/${selectedLocation.id}`;
    } else {
      alert("Unsupported hotel brand.");
      return;
    }

    const { data } = await api.post(
      endpoint,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const locationId =
      selectedLocation.id;

      const brand =
  selectedLocation.brand;

    handleCloseUpload();

   if (brand === "seahaus") {
  navigate(
    `/hospitality/seahaus/audits/${locationId}`
  );
} else {
  navigate(
    `/hospitality/audits/${locationId}`,
    {
      state: {
        audit: data.audit,
      },
    }
  );
}
  } catch (error) {
    console.error(
      "Night audit upload failed:",
      error
    );

    const backendError =
  error?.response?.data;

alert(
  backendError?.sqlMessage ||
  backendError?.error ||
  backendError?.message ||
  "Failed to upload night audit."
);
  } finally {
    setUploading(false);
  }
};

  return (
  <div className="hospitality-page">
    <h1>Hospitality Reporting</h1>


    <button
      type="button"
      className="hospitality-add-location-link"
      onClick={() => setShowLocationPopup(true)}
    >
      + Add Location
    </button>

    {showLocationPopup && (
      <div className="hospitality-popup-overlay">
        <div className="hospitality-popup">
          <div className="hospitality-popup-header">
            <h2>Add Location</h2>

            <button
              type="button"
              className="hospitality-popup-close"
              onClick={handleCloseLocationPopup}
            >
              ×
            </button>
          </div>

          <form onSubmit={handleLocationSubmit}>
            <label className="hospitality-label">
              Brand Name
            </label>

            <select
              className="hospitality-input"
              name="brand"
              value={locationForm.brand}
              onChange={handleLocationChange}
              required
            >
              <option value="">Select Brand</option>
              <option value="seahaus">Seahaus</option>
              <option value="marriott">Marriott</option>
              <option value="hilton">Hilton</option>
            </select>

            <label className="hospitality-label">
              Location
            </label>

            <input
              type="text"
              className="hospitality-input"
              name="location"
              value={locationForm.location}
              onChange={handleLocationChange}
              placeholder="Enter location"
              required
            />

            <div className="hospitality-popup-actions">
              <button
                type="button"
                className="hospitality-cancel-button"
                onClick={handleCloseLocationPopup}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="hospitality-submit-button"
              >
                Add Location
              </button>
            </div>
          </form>
        </div>
      </div>
    )}

    {showUploadPopup && selectedLocation && (
  <div className="hospitality-popup-overlay">
    <div className="hospitality-popup">
      <div className="hospitality-popup-header">
        <h4>Upload Night Audit</h4>

        <button
          type="button"
          className="hospitality-popup-close"
          onClick={handleCloseUpload}
        >
          ×
        </button>
      </div>

      <p>
  {selectedLocation.brand
    ? selectedLocation.brand.charAt(0).toUpperCase() +
      selectedLocation.brand.slice(1)
    : ""}{" "}
  - {selectedLocation.location}
</p>

      <form onSubmit={handleNightAuditUpload}>
        <label className="hospitality-label">
          Night Audit File
        </label>

        <input
          type="file"
          accept=".pdf,application/pdf"
          onChange={(e) => {
            setNightAuditFile(
              e.target.files?.[0] || null
            );
          }}
          required
        />

        <div className="hospitality-popup-actions">
          <button
            type="button"
            className="hospitality-cancel-button"
            onClick={handleCloseUpload}
            disabled={uploading}
          >
            Cancel
          </button>

          <button
            type="submit"
            className="hospitality-submit-button"
            disabled={uploading || !nightAuditFile}
          >
            {uploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

    <div className="hospitality-locations">
      <h2>Locations</h2>

      {locations.length === 0 ? (
        <p>No locations added yet.</p>
      ) : (
        <div className="hospitality-location-list">
          {locations.map((item) => (
            <div
  className="hospitality-location-card"
  key={item.id}
>
  <div className="hospitality-location-brand">
    {item.brand === "seahaus"
      ? "Seahaus"
      : item.brand === "hilton"
      ? "Hilton"
      : item.brand === "marriott"
      ? "Marriott"
      : item.brand}
  </div>

  <div className="hospitality-location-name">
    {item.location}
  </div>

  <div className="hospitality-location-recent">
    <span>Most Recent Audit:</span>

    <strong>
      {item.latest_report_date
        ? new Date(
            item.latest_report_date
          ).toLocaleDateString()
        : "No audits yet"}
    </strong>
  </div>

  <div className="hospitality-location-actions">

    <button
      type="button"
      className="hospitality-upload-audit-button"
      onClick={() => handleOpenUpload(item)}
    >
      Upload Night Audit
    </button>

    <button
  type="button"
  className="hospitality-view-audit-button"
  onClick={() => {
    if (item.brand === "seahaus") {
      navigate(
        `/hospitality/seahaus/audits/${item.id}`,
        {
          state: {
            reportDate:
              item.latest_report_date
                ? String(
                    item.latest_report_date
                  ).slice(0, 10)
                : "",
          },
        }
      );
    } else {
      navigate(
        `/hospitality/audits/${item.id}`
      );
    }
  }}
>
  Snapshot
</button>

  </div>
</div>
          ))}
        </div>
      )}
    </div>
  </div>
);
};

export default HospitalityPage;